import { z } from 'zod';

/**
 * Search params shared by all module routes to propagate the job context.
 *
 * `vagaId` is the job id (post journey-absorption). `phaseId` is the job_step
 * id; carried for navigation context, but no longer required by the submit
 * flow since `module_user_response` is keyed by `(user_id, module_id)` alone.
 */
export const moduleSearchSchema = z.object({
  vagaId: z.string().optional(),
  phaseId: z.string().min(1).max(80).optional(),
});
